/** User-facing product name for /vibe-studio (Chat Studio). */

export const CHAT_STUDIO_NAME = 'Chat Studio';

export const CHAT_STUDIO_SUBTITLE = 'Build and run SAP work through conversation';

export const STUDIO_WELCOME_MESSAGE =
  `Hi — I'm your ${CHAT_STUDIO_NAME} assistant for SAP work: ABAP, security and access, `
  + 'reports, workflows, and Integration Suite. What would you like to tackle today?';
